export const WishCategorySVG = (props) => (
  <svg
    height={45}
    viewBox="0 0 36 45"
    width={36}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd" stroke="#1d1d1b" strokeWidth={1.2}>
      <path d="M1.18 31.732V1h33.46v42.616H13.104" />
      <path d="M13.432 43.784V31.402H1z" strokeLinejoin="bevel" />
      <path d="M18.054 23.404l6.902-6.472v.001a4.079 4.079 0 10-6.052-5.438l-.85.964-.851-.964a4.079 4.079 0 10-6.052 5.438h0z" />
    </g>
  </svg>
);
